import api from '../api';
import { useRequest } from '../api/hooks';
import { Appointment } from './appointment';
import { DefaultServiceDuration } from './common';
import { isServiceOrderSKU, OrderDetail, PreOrder } from './order';
import { SKUSpecification } from './sku';
import { UserFullInfo } from './user';

export const STORAGE_KEY_POS_ORDERS_HISTORY = `pos-orders-history`;

export const getIsPaidOrder = (preorder: PreOrder) => {
  return Boolean(preorder.orderSn);
};

export const PreOrderEndpoint = `/preOrder`;

export const syncToServer = async (data: Record<string, PreOrder>) => {
  return api.post<void>({
    url: `${PreOrderEndpoint}/sync`,
    data,
  });
};
export const useSyncFromServer = () =>
  useRequest<Record<string, PreOrder>>(
    {
      method: 'get',
      url: `${PreOrderEndpoint}/sync`,
    },
    {
      manual: true,
    }
  );

export const startService = async (
  appointment: Partial<
    Pick<Appointment, 'startTime' | 'endTime' | 'id' | 'count' | 'orderSn' | 'checkinTime'>
  >
) => {
  return api.post<Appointment>({
    url: `${PreOrderEndpoint}/startService`,
    data: {
      ...appointment,
    },
  });
};

export const deleteService = async (
  appointment: Partial<Pick<Appointment, 'startTime' | 'endTime' | 'id' | 'count' | 'orderSn'>>
) => {
  return api.post<Appointment>({
    url: `${PreOrderEndpoint}/deleteService`,
    data: {
      ...appointment,
    },
  });
};

export const getPreOrderByOrderDetail: ({
  orderDetail,
  userFullInfo,
  appointment,
}: {
  userFullInfo: UserFullInfo;
  orderDetail: OrderDetail;
  appointment: Appointment;
}) => PreOrder = ({ orderDetail, userFullInfo, appointment }) => {
  const { order, skuList = [] } = orderDetail;
  return {
    specifications: skuList.map(orderSku => {
      return {
        number: 1,
        goodsId: orderSku.goodsId,
        goodsName: orderSku.goodsName,
        goodsPicUrl: orderSku.goodsPicUrl,
        goodsSn: orderSku.goodsSn,
        goodsType: orderSku.goodsType,
        // 服务时长
        goodsDuration: isServiceOrderSKU(orderSku)
          ? orderSku.goodsDuration || DefaultServiceDuration
          : 0,
      } as SKUSpecification;
    }),
    // cards: [],
    userFullInfo,
    orderSn: order?.orderSn,
    appointment,
  };
};
